import React from "react";
import { Avatar, Typography } from "@mui/material";
export const SAvatar = ({ name, size = 32, bgcolor = "#DFE3E8", color = "#637381", borderRadius = 1.5, src }) => {
    const initials = name
        .split(" ")
        .map((part) => part[0])
        .slice(0, 2)
        .join("")
        .toUpperCase();
    return (React.createElement(Avatar, { src: src, sx: { width: size, height: size, bgcolor, borderRadius: borderRadius } },
        React.createElement(Typography, { variant: "subtitle2", textTransform: "uppercase", color: color, lineHeight: 1 },
            name[0],
            name[1])));
};
